<th />
<th style="width: 50px;">Country</th>
<th>Admin Level</th>
<th>GeoJSON</th>
<th>Shapefile</th>
<th>Mapinfo</th>
<th>GeoPackage</th>
<th>CSV</th>
<th>Overpass</th>
